<template>
    <div class="animated fadeIn unearnsettlefrm">        
        <b-card>
            <div slot="header">
                {{ this.$route.meta.title }}
                <div class="card-header-actions">
                  <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="10" class="settlement-data">
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Debitur No. (CIF)</label></b-input-group-prepend>
                            <b-form-input v-model="model.custcode" readonly></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuCustomerShow=true">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Debitur Name</label></b-input-group-prepend>
                            <b-form-input v-model="model.CustName" readonly></b-form-input>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Tgl. Transfer</label></b-input-group-prepend>
                            <b-form-input v-model="model.tgltrf" type="date"></b-form-input>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Remarks</label></b-input-group-prepend>
                            <b-textarea v-model="model.remarks" ></b-textarea>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                </b-col>
            </b-row>   
            <hr>                       

            <b-row>
                <b-col lg="6">
                    <label class="text-center"><strong>Prepaid Asal</strong></label>
                    <b-card class="mb-2">
                        <b-input-group >
                            <b-input-group-prepend><label>Agreement No.</label></b-input-group-prepend>
                            <b-form-input v-model="prepaidDtfrom.no_agreement" readonly></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuPinjamanPrepaidShow=true;prepaidto=false;prepaidfrom=true;"  
                            :disabled="!model.custcode||model.custcode==''" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group> 
                         <b-input-group >
                            <b-input-group-prepend><label>Application No.</label></b-input-group-prepend>
                            <b-form-input v-model="prepaidDtfrom.no_kontrak" readonly></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Prepaid OS</label></b-input-group-prepend>
                            <my-number class="form-control text-right" 
                            separator="," 
                            v-model="prepaidDtfrom.pbbos" 
                            :precision="2" ></my-number>
                        </b-input-group>     
                    </b-card>

                </b-col>
                <b-col lg="6">
                    <label class="text-center"><strong>Prepaid Tujuan</strong></label>
                    <b-card class="mb-2" >
                        <b-input-group >
                            <b-input-group-prepend><label>Agreement No.</label></b-input-group-prepend>
                            <b-form-input v-model="prepaidDtto.no_agreement" readonly></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuPinjamanPrepaidShow=true;prepaidto=true;prepaidfrom=false;">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>  
                         <b-input-group >
                            <b-input-group-prepend><label>Application No.</label></b-input-group-prepend>
                            <b-form-input v-model="prepaidDtto.no_kontrak" readonly></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Prepaid OS</label></b-input-group-prepend>
                            <my-number class="form-control text-right" 
                            separator="," 
                            v-model="prepaidDtto.pbbos" 
                            :precision="2" disabled></my-number>
                        </b-input-group>  
                        <b-input-group >
                            <b-input-group-prepend><label>Prepaid Transfer</label></b-input-group-prepend>
                            <my-number class="form-control text-right" 
                            separator="," 
                            v-model="prepaidDtto.pbb_trf" 
                            :precision="2" disabled></my-number>
                        </b-input-group>  
                        <b-input-group >
                            <b-input-group-prepend><label>Total Prepaid After</label></b-input-group-prepend>
                            <my-number class="form-control text-right" 
                            separator="," 
                            v-model="prepaidDtto.totalpbb" 
                            :precision="2" disabled></my-number>
                        </b-input-group>     
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="justify-content-center mb-2">
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-append>
                                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()">
                                    <i class="fa fa-save"></i> Transfer</button>
                            </b-input-group-append>
                            <b-input-group-append>
                                <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>

            </b-row>
        </b-card>
        <b-modal v-model="lkuPinjamanPrepaidShow" size="lg" :hide-footer="true" :title="('List of Loan Prepaid (Prepaid ').concat((prepaidfrom?'From':'To'),')')" :centered="true">
            <lku-pinjamanprepaid 
            @click="onSelectLkuPjmnPrepaid" 
            :formdata="lkuPjmnPrepaidData" 
            :selectedrow="lkuPjmnPrepaidSelected"
            :searchdata="model"
            :pinjamankeynotin="pinjamankeynotin"
            ></lku-pinjamanprepaid>
        </b-modal>   
         <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Debitur" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>
    </div>
</template>
<style lang="scss">

    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 130px;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuPinjamanprepaid from "../lookup/lkuPinjamanPrepaidWithoutSearch";
import lkuPinjamanoutstand from "./lkuPinjamanoutstand";


import lkuArinv from "../lookup/lkuArinvLazzy2";
import lkuInstallment from "../lookup/lkuInstallment";
import lkuCustomer from "../lookup/lkuCustomer";
import dimension from "../../apis/dimension";
import lkuCashflow from "../lookup/lkuCashflow";
import arsettlement from '../../apis/arsettlement';
import { validationMixin } from "vuelidate";
import { required, requiredIf, requiredUnless, minValue, minLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, lkuInstallment, lkuArinv,lkuPinjamanprepaid,lkuPinjamanoutstand, lkuCustomer,lkuCashflow},
  mixins: [validationMixin],
  validations: {
        model: {
            // settleuraian: { required },
            // tglsettl: { required },
            // settleamt: { required, minValue:minValue(0.01) },
            // totalpbb: { required, minValue:minValue(0.00000001) }
        },
      arpaymdtObj :{
        pinjamankey: { required },
        nilaisettl_desc: { required },
        nilaisettl: {
          minValue: function () {
            if (this.adaPotongan) {
              return true;
            } else if ((this.arpaymdtObj.nilaisettl || 0) < 0.01) {
              return false;
            } else return true;
          },
      },
      nilaibank: {
        minValue: function () {
          if (this.adaPotongan) {
            return true;
          } else if ((this.arpaymdtObj.nilaibank || 0) < 0) {
            return false;
          } else return true;
        },
      },
      nilaidiskon: {
        required: function () {
          if ((this.arpaymdtObj.nilaibank || 0) > 0.01) {
            return true;
          } else if ((this.arpaymdtObj.nilaidiskon || 0) < 0) {
            return false;
          } else return true;
        },
      },
      kurssettle: { required:false, 
      // minValue: minValue(0.0000001)
      },
      kodecash: {
        required: function () {
          // if ((this.arpaymdtObj.nilaibank || 0) == 0) {
          //   return true;
          // } else if ((this.arpaymdtObj.kodecash || "") == "") {
          //   return false;
          // } else 
          return true;
        },
      },
        },
  }, 
  data() {
    return {
        prepaidDtfrom:{
          no_agreement:'',no_kontrak:'',pbbos:0
        },
        prepaidDtto:{
          no_agreement:'',no_kontrak:'',
            pbbos:0,pbb_trf:0,totalpbb:0
        },
        pinjamankeynotin:[],
        model:{settleno:'',
        settleuraian:'', 
        custcode:'', 
        customer_id:'',
        tgltrf:moment().format('YYYY-MM-DD'),remarks:'',
        prepaidDtfrom:{},prepaidDtto:{}
        },
        // ===================
        arGroups : [],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
        inputBerlanjut: 0,
        inputLineBerlanjut: 1,
        
        pbb:{jenis:'Giro',kodecash:'',kodebank:'',kurstrx:1,tglpaym:'',tgl_terima:'', matauang:'',totalbyr:'', custcode:'', customer_id:''},
        lblExchRate:"Exch. Rate ",
        bankOnly:1,
        totalDtlPaym:0,
        unsttlpbb: 0,
        updateDimHdr:false,
        updateDimDtl:true,
        arpaymdt: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "loaninfo",
                    thStyle: "width:150px",
                    label: "No Loan | Installment No. ",
                    sortable: true
                },
                {
                    key: "nilaisettl_desc",
                    label: "Jenis Settlement",
                    thStyle: "width:150px",
                    sortable: true
                },
                {
                    key: "tgl_jttempo",
                    label: "Tgl Jth. Tempo",
                    thStyle: "width:100px",
                    sortable: true
                },
                
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "CCY",
                    sortable: true
                },
                {
                    key: "nilaibyr",
                    label: "Nilai Settlement",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                // {
                //     key: "kurskeAR",
                //     label: "Exch.Rate to Original",
                //     thStyle: "width:100px",
                //     thClass: "text-right",
                //     tdClass: "text-right"
                // },
                {
                    key: "nilaibank",
                    label: "Settlement Prepaid",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kasdiskon",
                    label: "Settlement Discount",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                // {
                //     key: "selisihkurs",
                //     label: "Gain/(Loss) Exch.Rate",
                //     thStyle: "width:80px",
                //     thClass: "text-right",
                //     tdClass: "text-right"
                // },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:120px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },

            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arpaymdtObj:{arinvKey:'',
         kodecash:'',
          IDPotongan:'',
         kasdiskon:0,
         nilaibank:0,
         nilaisettl:0,
         nilaibyr:0},
        lkuCustomerShow:false,
        lkuInstallmentShow:false,
        lkuCashflowShow:false,
        lkuInstallmentData:{},
        lkuInstallmentFilterData:{},
        lkuInstallmentSelected:[],
        lkuArinvShow: false,
        lkuArInvData:{},
        lkuPinjamanPrepaidShow:false,
        lkuPjmnPrepaidData:{},
        lkuPjmnPrepaidSelected:[],
        lkuPinjamanoutstandShow: false,
        lkuPinjamanoutstandData: {},
        selectedPinjamanOS: [],
        addPrincipInterest:1,
        tabIndex:0,
        prepaidfrom:false,
        prepaidto:false
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    adaPotongan(){
        return ((this.arpaymdtObj.kasdiskon || 0) != 0);
    },
    IDPotongan(){return this.arpaymdtObj.IDPotongan;},
    adaNilaiBank(){return ((this.arpaymdtObj.nilaibank || 0) != 0);},
  },
  watch: {
    "prepaidDtfrom.pbbos":function(val){
      this.prepaidDtto.pbb_trf = val;
      this.prepaidDtto.totalpbb = val + this.prepaidDtto.pbbos;
    }
  },
  created: async function(){
      const [a] = await Promise.all([arsettlement.currency()]) ;
      this.currency = a;
      this.model.matauang=this.uanguser;
      this.model.tgltrf = moment().format('YYYY-MM-DD');

      
  },
  methods: {
    onSelectLkuPjmnPrepaid: async function (data) {
      try {
        const {selected} = data;
        if(this.prepaidfrom){
          this.prepaidDtfrom={
            no_agreement:selected.no_agreement,
            no_kontrak:selected.no_kontrak,
            pbbos:selected.pbb_ost
          }
          this.pinjamankeynotin.push(selected.pinjamankey);
        }

        if(this.prepaidto){
          this.prepaidDtto={
            no_agreement:selected.no_agreement,
            no_kontrak:selected.no_kontrak,
              pbbos:selected.pbb_ost,
              pbb_trf:this.prepaidDtfrom.pbbos,
              totalpbb:(selected.pbb_ost+this.prepaidDtfrom.pbbos)
          };
        }

      } catch (error) {
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        } 
      }
        this.lkuPinjamanPrepaidShow=false;

    },
    onSelectLkuCustomer: async function (_selected) {
        this.pbb.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.customer_id = _selected.customer_id || _selected.nasabahkey;
        this.model.CustName=_selected.CustName.trim();
        this.lkuCustomerShow=false;
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) {
            toastr.warn('Detail Form Un Saved');
            this.saveEnabled=true;
            return;
        }
        this.model.settleamt=this.totalDtlPaym;
        this.model.kurstrx = this.pbb.kurstrx;
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else if ((this.totalDtlPaym)> parseFloat(this.model.totalpbb+this.model.totaldiskon)) {
            console.log('this.totalDtlPaym',this.totalDtlPaym);
            console.log('this.model.totalpbb',this.model.totalpbb);
            toastr.error('[Total Detail Settlement] is greater than [Unearned Inc. BALANCE]', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
              this.model.prepaidDtfrom = this.prepaidDtfrom;
              this.model.prepaidDtto = this.prepaidDtto;
              const hasil= await arsettlement.transfer(this.model);
              toastr.success(`Success, Trx.Number ${hasil.paymno}`, "Save PBB Transfer",10000);
              this.saveEnabled=true;
              this.close();
            } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    closeArPayment: function(){
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name!=='receivable.pbbsettlefrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'loan.pbbtransfer'});
      }
    }
  }
};
</script>
